import { Article } from 't2-graphql-types';
import { UseFormReturn } from 'react-hook-form';
import { TGetModalComponent } from '../Modal/useModal';
import { EditPromptForm } from './EditPromptForm';
import { TPromptFormFields } from '../PromptForm/types';

type TEditPromptModalProps = {
  ModalComponent: TGetModalComponent;
  closeModal: () => void;
  useFormReturn: UseFormReturn<TPromptFormFields>;
  promptData: Article;
};

export const EditPromptModal = ({ ModalComponent, closeModal, useFormReturn, promptData }: TEditPromptModalProps) => (
  <ModalComponent title="Edit prompt" containerClassName="sm:!max-h-[90%]">
    <EditPromptForm closeModal={closeModal} useFormReturn={useFormReturn} promptData={promptData} />
  </ModalComponent>
);
